import createNotification from './createNotification';
import lotteryTabs from './lotteryTabs';
import styleSelect from './styleSelect';
import utility from './utility';

const accountPersonalDetails = {
    init: function() {
        const accountSection = document.getElementById("account--landing");
        if (!accountSection) {
            return;
        }

        const editPersonalDetailsButton = document.querySelector("#account--personal-details-edit");
        if (editPersonalDetailsButton) {
            editPersonalDetailsButton.onclick = () => accountPersonalDetails.showPersonalDetails();
        }

        accountPersonalDetails.configurePersonalDetailsForm();
    },

    showPersonalDetails: function() {
        const ajaxOptions = {
            url: "/api/web/account/get-personal-details",
            method: "GET",
            success: function(e) {
                document.getElementById("account--personal-details-container").innerHTML = e.target.responseText;
                styleSelect.init("#account--personal-details-container select");
                lotteryTabs.init(document.querySelector("#account--personal-details-container"));
                accountPersonalDetails.configurePersonalDetailsForm();
                utility.showPopup(document.getElementById("account--personal-details-popup"));
            },
            always: function(e) {
                utility.enableButton(document.getElementById("account--personal-details-edit"));
            }
        };
        utility.disableButton(document.getElementById("account--personal-details-edit"));
        utility.ajaxRequest(ajaxOptions);
    },

    configurePersonalDetailsForm: function() {
        const personalDetailsForm = document.querySelector("#account--personal-edit");
        if (personalDetailsForm) {
            personalDetailsForm.onsubmit = (e) => {
                e.preventDefault();
                accountPersonalDetails.updatePersonalDetails();
            };
            [...personalDetailsForm.querySelectorAll("input[name='BirthDate'], input[name='BirthMonth'], input[name='BirthYear']")].map(item => {
                item.onkeypress = (e) => {
                    if (e.charCode < 48 || e.charCode > 57){
                        e.preventDefault();
                    }
                };
            });
        }

        const countryInput = document.querySelector("#account--personal-edit select[name='CountryCode']");
        if (countryInput) {
            countryInput.onchange = () => {
                accountPersonalDetails.setAddressStateInput();
            }
            accountPersonalDetails.setAddressStateInput();
        }

        const sendEmailVerifiation = document.getElementById("account--verify-email");
        if (sendEmailVerifiation) {
            sendEmailVerifiation.onclick = (e) => {
                e.preventDefault();
                accountPersonalDetails.sendVerifyEmailNotification();
            }
        }

        const sendMobileVerification = document.getElementById("account--verify-mobile");
        if (sendMobileVerification) {
            sendMobileVerification.onclick = (e) => {
                e.preventDefault();
                accountPersonalDetails.sendVerifyMobileNotification();
            }
        }
    },

    setAddressStateInput: function() {
        const countryInput = document.querySelector("#account--personal-edit select[name='CountryCode']");
        if (countryInput && (countryInput.value === "" || countryInput.value === "AU")) {
            document.querySelector("#account--personal-details-state-other").style.display = "none";
            document.querySelector("#account--personal-details-state-au").style.display = "";
            document.querySelector("#account--personal-details-state-other input").name = "";
            document.querySelector("#account--personal-details-state-au select").name = "State";
        }
        else {
            document.querySelector("#account--personal-details-state-other").style.display = "none";
            document.querySelector("#account--personal-details-state-au").style.display = "none";
            document.querySelector("#account--personal-details-state-other input").name = "State";
            document.querySelector("#account--personal-details-state-au select").name = "";
        }
    },

    updatePersonalDetails: function () {
        const emailInput = document.querySelector("#account--personal-edit input[name='Email']");
        if (emailInput && emailInput.dataset.logintype === "L" && emailInput.dataset.original !== emailInput.value.trim()) {
            const options = accountPersonalDetails.getUpdatePersonalDetailsAjaxOptions();
            utility.showNotificationPopup({
                title: "Warning",
                content: "You are about to change your email address, after the change you'll need to use your new email to log in.",
                hideCloseIcon: false,
                button: {
                    text: "OK",
                    ajaxOptions: options
                }
            });
        }
        else {
            accountPersonalDetails.requestUpdatePersonalDetails();
        }
    },

    requestUpdatePersonalDetails: function () {
        utility.disableButton(document.querySelector("#account--personal-edit button[type=submit]"));
        utility.ajaxRequest(accountPersonalDetails.getUpdatePersonalDetailsAjaxOptions());
    },

    getUpdatePersonalDetailsAjaxOptions: function() {
        return {
            url: "/api/web/account/update-personal-details",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--personal-edit")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#account--personal-edit");
                utility.removeFormInputErrors(form);

                if (result.resultCode === "OK") {
                    utility.hidePopups();
                    createNotification("Your personal details have been updated");
                }
                else if (result.resultCode === "IF") {
                    utility.showPopup(document.getElementById("account--personal-details-popup"));
                    utility.addFormInputErrors(form, result.fieldErrors);
                    utility.scrollToFormError(form, result.fieldErrors);
                }
                else if (result.resultCode === "DIS") {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: "/"
                        }
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.message
                    });
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#account--personal-edit button[type=submit]"));
            }
        };
    },

    sendVerifyEmailNotification: function() {
        const ajaxOptions = {
            url: "/api/web/account/send-verify-email-notification",
            method: "POST",
            responseType: "text",
            success: function(e) {
                utility.showNotificationPopup({
                    title: "Success!",
                    content: "A verification notification has been sent to your email address."
                });
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    sendVerifyMobileNotification: function() {
        const ajaxOptions = {
            url: "/api/web/account/send-verify-mobile-notification",
            method: "POST",
            responseType: "text",
            success: function(e) {
                utility.showNotificationPopup({
                    title: "Success!",
                    content: "A verification notification has been sent to your mobile phone."
                });
            }
        };
        utility.ajaxRequest(ajaxOptions);
    }
};

export default accountPersonalDetails;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountPersonalDetails.js